import { useState } from "react";
import { genreCards, genreFilters } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function GenreSection() {
  const [filter, setFilter] = useState("all");
  const visible = filter === "all" ? genreCards : genreCards.filter((card) => card.category === filter);

  return (
    <section id="genres" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="剧集类型"
          title="不同类型的剧，缓存和离线的方式也不一样"
          description="按类型挑选内容，能更快决定缓存清晰度和集数。点击标签筛选，看看哪一类更适合你现在缓存到手机上。"
        />

        <div className="mt-7 flex flex-wrap gap-2 md:mt-9">
          {genreFilters.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => setFilter(item.key)}
              className={`rounded-full border px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors ${
                filter === item.key
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-300 bg-background-100 text-foreground-600 hover:border-primary-300 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        {visible.length > 0 ? (
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:mt-8 md:gap-5">
            {visible.map((card) => (
              <article
                key={card.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center justify-between">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-900">
                    {card.categoryLabel}
                  </span>
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-play-list-2-line text-base text-accent-800"></i>
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 md:text-lg">
                  {card.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{card.desc}</p>
                <div className="mt-4 flex items-center gap-2 border-t border-background-200 pt-3">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-time-line text-base text-primary-500"></i>
                  </span>
                  <span className="text-xs font-medium text-foreground-500">推荐场景 · {card.fit}</span>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-6 rounded-lg border border-dashed border-background-300 bg-background-100 p-10 text-center">
            <p className="text-sm text-foreground-600">该类型暂时没有条目，换个标签看看。</p>
          </div>
        )}
      </div>
    </section>
  );
}